export default class Utils {

  static getMissingWelcomeMessages(notifications, store) {
    const currentNotificationCombinations = []
    notifications.filter(n => n.type !== 'welcome' && n.status !== 'draft')
      .forEach((n) => {
        const lang = n.segments && n.segments.browserLanguage[0]
        const domains = n.segments && n.segments.domain && n.segments.domain.length !== 0 ? n.segments.domain : store.domains
        domains.forEach((domain) => {
          const combination = `${domain} ${lang}`
          if (!currentNotificationCombinations.includes(combination)) {
            currentNotificationCombinations.push(combination)
          }
        })
      })
    const welcomeCombinations = [];
    notifications.filter(n => n.type === 'welcome')
      .forEach((n) => {
        const lang = n.segments && n.segments.browserLanguage[0]
        const domains = n.segments && n.segments.domain && n.segments.domain.length !== 0 ? n.segments.domain : store.domains
        domains.forEach((domain) => {
          const combination = `${domain} ${lang}`
          if (!welcomeCombinations.includes(combination)) {
            welcomeCombinations.push(combination)
          }
        })
      })
    const neededCombinations = currentNotificationCombinations.filter(c => !welcomeCombinations.includes(c))
    const needed = {}
    neededCombinations.forEach((c) => {
      const a = c.split(' ')
      if (!needed[a[1]]) {
        needed[a[1]] = []
      }
      if (!needed[a[1]].includes(a[0])) {
        needed[a[1]].push(a[0])
      }
    })
    // console.log(currentNotificationCombinations, welcomeCombinations, neededCombinations)
    return needed
  }

  static getExistingTriggeredMessages(notifications, store, type) {
    const currentTriggeredCombinations = {}
    notifications.filter(n => n.type === type)
      .forEach((n) => {
        if (n.status === 'draft') {
          return
        }
        if (n.segments) {
          n.segments.browserLanguage.forEach((l) => {
            // if (!l) {
            //   return
            // }
            const lang = l
            const domains = n.segments && n.segments.domain && n.segments.domain.length !== 0 ? n.segments.domain : store.domains
            domains.forEach((domain) => {
              if (!currentTriggeredCombinations[lang]) {
                currentTriggeredCombinations[lang] = []
              }
              if (!currentTriggeredCombinations[lang].includes(domain)) {
                currentTriggeredCombinations[lang].push(domain)
              }
            })
          })
        }
      })
    // console.log(currentTriggeredCombinations)
    return currentTriggeredCombinations
  }

  static wrapEmojis(str, startWrapper, endWrapper) {
    // emoji 11.0
    // greedy .. so it will get those that are connected by ZWJ and just singles ones sitting next to each other ...
    const reg = new RegExp('([\u{0023}\u{002A}\u{0030}-\u{0039}\u{00A9}\u{00AE}\u{203C}\u{2049}\u{2122}]\u{FE0F}\u{20E3}?|[\u{2139}\u{2194}-\u{2199}\u{21A9}-\u{21AA}\u{231A}-\u{231B}\u{2328}\u{23CF}\u{23E9}-\u{23F3}\u{23F8}-\u{23FA}\u{24C2}\u{25AA}-\u{25AB}\u{25B6}\u{25C0}\u{25FB}-\u{25FE}\u{2600}-\u{2604}\u{260E}\u{2611}\u{2614}-\u{2615}\u{2618}\u{261D}\u{2620}\u{2622}-\u{2623}\u{2626}\u{262A}\u{262E}-\u{262F}\u{2638}-\u{263A}\u{2640}\u{2642}\u{2648}-\u{2653}\u{265F}-\u{2660}\u{2663}\u{2665}-\u{2666}\u{2668}\u{267B}\u{267E}-\u{267F}\u{2692}-\u{2697}\u{2699}\u{269B}-\u{269C}\u{26A0}-\u{26A1}\u{26AA}-\u{26AB}\u{26B0}-\u{26B1}\u{26BD}-\u{26BE}\u{26C4}-\u{26C5}\u{26C8}\u{26CE}\u{26CF}\u{26D1}\u{26D3}-\u{26D4}\u{26E9}-\u{26EA}\u{26F0}-\u{26F5}\u{26F7}-\u{26FA}\u{26FD}\u{2702}\u{2705}\u{2708}-\u{2709}\u{270A}-\u{270B}\u{270C}-\u{270D}\u{270F}\u{2712}\u{2714}\u{2716}\u{271D}\u{2721}\u{2728}\u{2733}-\u{2734}\u{2744}\u{2747}\u{274C}\u{274E}\u{2753}-\u{2755}\u{2757}\u{2763}-\u{2764}\u{2795}-\u{2797}\u{27A1}\u{27B0}\u{27BF}\u{2934}-\u{2935}\u{2B05}-\u{2B07}\u{2B1B}-\u{2B1C}\u{2B50}\u{2B55}\u{3030}\u{303D}\u{3297}\u{3299}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F171}\u{1F17E}\u{1F17F}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F1E6}-\u{1F1FF}\u{1F201}-\u{1F202}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F23A}\u{1F250}-\u{1F251}\u{1F300}-\u{1F320}\u{1F321}\u{1F324}-\u{1F32C}\u{1F32D}-\u{1F32F}\u{1F330}-\u{1F335}\u{1F336}\u{1F337}-\u{1F37C}\u{1F37D}\u{1F37E}-\u{1F37F}\u{1F380}-\u{1F393}\u{1F396}-\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}-\u{1F39F}\u{1F3A0}-\u{1F3C4}\u{1F3C5}\u{1F3C6}-\u{1F3CA}\u{1F3CB}-\u{1F3CE}\u{1F3CF}-\u{1F3D3}\u{1F3D4}-\u{1F3DF}\u{1F3E0}-\u{1F3F0}\u{1F3F3}-\u{1F3F5}\u{1F3F7}\u{1F3F8}-\u{1F3FF}\u{1F400}-\u{1F43E}\u{1F43F}\u{1F440}\u{1F441}\u{1F442}-\u{1F4F7}\u{1F4F8}\u{1F4F9}-\u{1F4FC}\u{1F4FD}\u{1F4FF}\u{1F500}-\u{1F53D}\u{1F549}-\u{1F54A}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F56F}-\u{1F570}\u{1F573}-\u{1F579}\u{1F57A}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F590}\u{1F595}-\u{1F596}\u{1F5A4}\u{1F5A5}\u{1F5A8}\u{1F5B1}-\u{1F5B2}\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}\u{1F5FB}-\u{1F5FF}\u{1F600}\u{1F601}-\u{1F610}\u{1F611}\u{1F612}-\u{1F614}\u{1F615}\u{1F616}\u{1F617}\u{1F618}\u{1F619}\u{1F61A}\u{1F61B}\u{1F61C}-\u{1F61E}\u{1F61F}\u{1F620}-\u{1F625}\u{1F626}-\u{1F627}\u{1F628}-\u{1F62B}\u{1F62C}\u{1F62D}\u{1F62E}-\u{1F62F}\u{1F630}-\u{1F633}\u{1F634}\u{1F635}-\u{1F640}\u{1F641}-\u{1F642}\u{1F643}-\u{1F644}\u{1F645}-\u{1F64F}\u{1F680}-\u{1F6C5}\u{1F6CB}-\u{1F6CF}\u{1F6D0}\u{1F6D1}-\u{1F6D2}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6EB}-\u{1F6EC}\u{1F6F0}\u{1F6F3}\u{1F6F4}-\u{1F6F6}\u{1F6F7}-\u{1F6F8}\u{1F6F9}\u{1F910}-\u{1F918}\u{1F919}-\u{1F91E}\u{1F91F}\u{1F920}-\u{1F927}\u{1F928}-\u{1F92F}\u{1F930}\u{1F931}-\u{1F932}\u{1F933}-\u{1F93A}\u{1F93C}-\u{1F93E}\u{1F940}-\u{1F945}\u{1F947}-\u{1F94B}\u{1F94C}\u{1F94D}-\u{1F94F}\u{1F950}-\u{1F95E}\u{1F95F}-\u{1F96B}\u{1F96C}-\u{1F970}\u{1F973}-\u{1F976}\u{1F97A}\u{1F97C}-\u{1F97F}\u{1F980}-\u{1F984}\u{1F985}-\u{1F991}\u{1F992}-\u{1F997}\u{1F998}-\u{1F9A2}\u{1F9B0}-\u{1F9B9}\u{1F9C0}\u{1F9C1}-\u{1F9C2}\u{1F9D0}-\u{1F9E6}\u{1F9E7}-\u{1F9FF}\u{23E9}-\u{23EC}\u{23F0}\u{23F3}\u{25FD}-\u{25FE}\u{267F}\u{2693}\u{26A1}\u{26D4}\u{26EA}\u{26F2}-\u{26F3}\u{26F5}\u{26FA}\u{1F201}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F3F4}\u{1F6CC}\u{1F3FB}-\u{1F3FF}\u{26F9}\u{1F385}\u{1F3C2}-\u{1F3C4}\u{1F3C7}\u{1F3CA}\u{1F3CB}-\u{1F3CC}\u{1F442}-\u{1F443}\u{1F446}-\u{1F450}\u{1F466}-\u{1F469}\u{1F46E}\u{1F470}-\u{1F478}\u{1F47C}\u{1F481}-\u{1F483}\u{1F485}-\u{1F487}\u{1F4AA}\u{1F574}-\u{1F575}\u{1F645}-\u{1F647}\u{1F64B}-\u{1F64F}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F6C0}\u{1F918}\u{1F919}-\u{1F91C}\u{1F91E}\u{1F926}\u{1F933}-\u{1F939}\u{1F93D}-\u{1F93E}\u{1F9B5}-\u{1F9B6}\u{1F9B8}-\u{1F9B9}\u{1F9D1}-\u{1F9DD}\u{200D}\u{20E3}\u{FE0F}\u{1F9B0}-\u{1F9B3}\u{E0020}-\u{E007F}\u{2388}\u{2600}-\u{2605}\u{2607}-\u{2612}\u{2616}-\u{2617}\u{2619}\u{261A}-\u{266F}\u{2670}-\u{2671}\u{2672}-\u{267D}\u{2680}-\u{2685}\u{2690}-\u{2691}\u{2692}-\u{269C}\u{269D}\u{269E}-\u{269F}\u{26A2}-\u{26B1}\u{26B2}\u{26B3}-\u{26BC}\u{26BD}-\u{26BF}\u{26C0}-\u{26C3}\u{26C4}-\u{26CD}\u{26CF}-\u{26E1}\u{26E2}\u{26E3}\u{26E4}-\u{26E7}\u{26E8}-\u{26FF}\u{2700}\u{2701}-\u{2704}\u{270C}-\u{2712}\u{2763}-\u{2767}\u{1F000}-\u{1F02B}\u{1F030}-\u{1F093}\u{1F0A0}-\u{1F0AE}\u{1F0B1}-\u{1F0BE}\u{1F0BF}\u{1F0C1}-\u{1F0CF}\u{1F0D1}-\u{1F0DF}\u{1F0E0}-\u{1F0F5}\u{1F12F}\u{1F260}-\u{1F265}\u{1F321}-\u{1F32C}\u{1F394}-\u{1F39F}\u{1F3F1}-\u{1F3F7}\u{1F3F8}-\u{1F3FA}\u{1F4FD}-\u{1F4FE}\u{1F546}-\u{1F54A}\u{1F54B}-\u{1F54F}\u{1F568}-\u{1F579}\u{1F57B}-\u{1F5A3}\u{1F5A5}-\u{1F5FA}\u{1F6C6}-\u{1F6CF}\u{1F6D3}-\u{1F6D4}\u{1F6E0}-\u{1F6EC}\u{1F6F0}-\u{1F6F3}\u{1F7D5}-\u{1F7D8}\u{1FA60}-\u{1FA6D}]+)', 'gu')
    return str.replace(reg, `${startWrapper}$1${endWrapper}`)
  }
  
  static getDefaultDefinition() {
    return {
      productType: '', // used for triggered
      extraDetails: false,
      title: '',
      titleSmall: '',
      body: '',
      bodySmall: '',
      icon: '',
      image: '',
      action1Text: '',
      action2Text: '',
      action1TextSmall: '',
      action2TextSmall: '',
      actionDefaultUrl: '',
      action1Url: '',
      action2Url: '',
      actionRequired: false,
      domain: '',
      extraUrlParameters: ''
    }
  }
}
